import { render, staticRenderFns } from "./customerDetail.vue?vue&type=template&id=57ed0fbd&scoped=true&"
import script from "./customerDetail.vue?vue&type=script&lang=js&"
export * from "./customerDetail.vue?vue&type=script&lang=js&"
import style0 from "./customerDetail.vue?vue&type=style&index=0&id=57ed0fbd&lang=stylus&scoped=true&"
import style1 from "./customerDetail.vue?vue&type=style&index=1&id=57ed0fbd&scoped=true&lang=css&"
import style2 from "./customerDetail.vue?vue&type=style&index=2&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ed0fbd",
  null
  
)

export default component.exports